
<template>
    <div>
        <div>
          <HeadDetailsGama :titleHead="'Retornar'" :buttontemplate="true" :buttonbackCustom="true" style="font-family: 'Segoe UI';"></HeadDetailsGama>
          <inqueryPdfQma ref="inqueryPdfQma" :qma="qma"></inqueryPdfQma>
        </div>

        <div class="mt-2">
          <collapseQma ref="collapse" :propQma="propQma" :qma="qma"></collapseQma>
        </div>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import { loading } from '@/shared/utils/UIHelper'
import inqueryPdfQma from '@/views/private/qma/inqueryQma/components/details/inqueryPdfQma/inqueryPdfQma.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import collapseQma from '@/views/private/qma/inqueryQma/components/details/detailsQma/components/collapseQma/collapseQma.vue'
import inqueryQmaRepository from '@/shared/http/repositories/business/qmaInquery'
export default {
  name: 'QmaDetails',
  mixins: [ActionsForm, ExpenseMixin],
  components: {HeadDetailsGama, collapseQma, inqueryPdfQma},
  data () {
    return {
      form: {
        obraid: {
          value: null,
          options: [],
          required: false,
          state: null,
          code: null
        }
      },
      localDisplay: '',
      memory: null,
      idQma: null
    }
  },
  props: ['qma', 'propQma'],
  watch: {
  },
  mounted () {

  },
  methods: {
    onLoad (value) {
      if (value === null || value === undefined) {
        const params = new URLSearchParams(window.location.search)
        const detalhesId = params.get('Detalhes')
        if (detalhesId) {
          this.idQma = detalhesId
          this.getQmaSelected(this.idQma)
        }
      }
      this.$refs.collapse.onLoad(value)
    },
    getQmaSelected (value) {
      loading.push()
      inqueryQmaRepository.GetQmaSelected(value)
        .then(response => {
          loading.pop()
          this.memory = response.data
          this.$refs.collapse.onLoad(this.memory)
        })
        .catch(() => {
          loading.pop()
        })
    }
  }
}

</script>

<style scoped>
.buttons-table-action{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: right;
    align-items: center;
}

.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 8px;
    border: none;
    font-weight: bold;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.labelsearch{
    font-weight: 700;
    color: #666;
    font-size: 14px;
    margin-bottom: 5px;
    padding-bottom: 0;
    font-family: 'Segoe UI';
}
.title-apr{
    color: #008148;
    font-family: "Segoe UI";
    font-weight: bold;
    font-size: 16px;
}
.date-form{
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
}
.area-select{
  width: 50%;
}
.validade-apr{
  width: 25%;
}
.data-apr{
  width: 25%;
}
.texts {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.local-obra {
  display: flex;
  gap: 1rem;
}
.title-checklist {
  font-size: 16px;
  color: #008144;
  font-family: 'Segoe UI';
  font-weight: bold;
}
.button-cancel,
.button-save{
margin-top: 10;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.button-cancel{
background-color: #D8D8D8;
color: #636363;
}
.button-save{
background-color: #008148;
color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/components/details/detailsQma/detailsQma.vue